'use strict';

import {oauth} from '../../../services/oauth/oauth';
import {ferry} from '../../../services/ferry/ferry';
import {AUTH_COOKIES, set_cookie, delete_cookie} from '../../../services/sessionState/cookies';

export class oauthRegister {
    constructor($scope, $routeParams) {
        var zephyrCompanyId = $routeParams.company;

        AUTH_COOKIES.forEach(to_remove => delete_cookie(to_remove));

        if (zephyrCompanyId) {
            set_cookie('zephyr_company', zephyrCompanyId);
        }

        $scope.startFlow = () => {
            set_cookie("no_login", true);
            $scope.ui = {
                waiting: true
            };

            oauth.oAuthConnect('gust', "disallowed").then(function(auth_details) {
                delete_cookie('no_login');
                ferry.call('/ferry/register/zephyr', {token: auth_details.request_token}).then(function(response) {
                    document.location.href = '/app/onboarding';
                }).catch(function(error) {
                    var parsedError = JSON.parse(error.message);
                    if ("Company already exists." === parsedError.message) {
                        $scope.ui = {
                            errorMessage: "You've already registered using your Gust.com account.",
                            showLogin: true,
                            waiting: false
                        };
                        $scope.$apply();
                    }
                });
            }).catch(function(error) {
                console.error(error)
                delete_cookie('no_login');
                if (error === 'pop up blocked') {
                    $scope.ui = {
                        errorMessage: "Your browser is blocking pop ups from this site. Please enable pop ups and register for a Gust.com account.",
                        waiting: false
                    };
                    $scope.$apply();
                }
            });
        };
    }
}

oauthRegister.$inject = ['$scope', '$routeParams'];



// WEBPACK FOOTER //
// ./_src/ui/preLoginApp/companyRegistration/oauthRegister.js